import axios from "axios";
import { useEffect, useState } from "react";
// import PlanDetailsCard from "./PlanDetailsCard";
import { Backdrop, CircularProgress } from "@mui/material";
import PlanDetailsCard from "../PlanDetailsCard";

const GlobalPlans = ({ plansList, isLoading , retailerType }) => {

    console.log("retailerType------>",retailerType);
    
    const [showModal, setShowModal] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
   
    const top = "#3624A8"
    const bottom = "#0049D6"

    const cardStyles = {
        background: `linear-gradient(to bottom, ${top || '#33ccff'} 0%, ${bottom || '#ff99cc'} 100%)`,
        color: 'white'
    };

    const buttonStyle = {
        background: `#0D005D`,
        color: 'white'
    }

    const handleCardClick = (plan) => {
        setSelectedPlan(plan);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedPlan(null);
    };

    return (
        <div className="container mt-4">
            <br />
            <br />
            <div className="row" >

                {isLoading ? (
                    <Backdrop
                        open={true}
                        style={{
                            color: '#fff',
                            zIndex: 9999,
                        }}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                ) : (
                    plansList && plansList.map((plan, index) => (
                        <div className="col-lg-6 col-md-12 mb-4 col=sm-12" key={index} onClick={() => handleCardClick(plan)} style={{ cursor: 'pointer' }}>
                            <div className="card global-plan-card" style={cardStyles}>
                                <div className="card-header d-flex justify-content-between align-items-center" translate="no">
                                    {plan.common_plan_name}
                                    <img src={plan.plan_image} alt="Card image" />
                                </div>
                                <div className="card-body">
                                    <b><i className="fas fa-globe"></i> Coverage <span translate="no"> Global</span></b>
                                    <hr />
                                    <b><i className="fas fa-arrow-up"></i> Data <span> {plan.plan_data} GB</span></b>
                                    <hr />
                                    <b><i className="fas fa-calendar-alt"></i> Validity <span> {plan.plan_validity} DAYS</span></b>
                                    <hr />
                                    <b><i className="fas fa-tag"></i> Price <span>AU ${retailerType === "PAR" ? (plan.prosegur_amount ?? '') : plan.rtap_amount} </span></b>
                                    
                                    <button className="btn btn-custom btn-block value-btn" style={buttonStyle}>AU $ {retailerType === "PAR" ? (plan.prosegur_amount ?? '') : plan.rtap_dealer_amount} - Buy Now</button>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {showModal && selectedPlan && (
                <PlanDetailsCard
                    show={showModal}
                    button="#0D005D"
                    top="#3624A8"
                    bottom="#0049D6"
                    countrySlug="global"
                    planSlug={selectedPlan.plan_slug}
                    retailerType={retailerType}
                    handleClose={handleCloseModal}
                />
            )}
        </div>
    );
}

export default GlobalPlans;
